import { render, staticRenderFns } from "./cartao-verso.vue?vue&type=template&id=78db14ce&scoped=true"
import script from "./cartao-verso.vue?vue&type=script&lang=js"
export * from "./cartao-verso.vue?vue&type=script&lang=js"
import style0 from "./cartao-verso.vue?vue&type=style&index=0&id=78db14ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78db14ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VCardText,
  VIcon,
  VMenu,
})
